<div #flowContainer class="baa-flow-container flex flex-col overflow-y-auto sm:overflow-hidden">
  <div class="container mt-3 flex items-center justify-center px-10 xs:justify-start">
    <img class="h-[48px]" src="assets/images/notes-logo-header.svg" height="48" alt="FFD Notes" />
  </div>

  <div class="mb-6 flex flex-col xs:h-full xs:items-center xs:justify-center">
    <div class="mx-4 mt-8 flex flex-col rounded-[26px] bg-background-white p-6 shadow-lg xs:mx-0 xs:mt-0 xs:w-[540px] xs:p-12">
      @if (service.isInitializingSignal()) {
        <ng-lottie [options]="lottieOptions" currentColor class="self-center text-primary-blue" />
      } @else {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</div>
